import {createSlice} from "@reduxjs/toolkit";

export const cartSlice = createSlice({
  name: "data",
  initialState: {
    cartData: [1, 2, 3, 4, 5],
  },
  reducers: {},
  extraReducers: {},
});

export const {} = cartSlice.actions;

export default cartSlice.reducer;
